import React, { Component } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';  



import { FaSearch, FaCheck, FaCheckDouble } from 'react-icons/fa';
import { FiEdit3 } from 'react-icons/fi';


import { MdAddCircleOutline, MdClose, MdTextsms  } from 'react-icons/md'; //GoIssueClosed
import { GoIssueClosed, GoChecklist } from 'react-icons/go'; //GoIssueClosed  AiOutlineFileSearch
import { AiOutlineFileSearch } from 'react-icons/ai'; //GoIssueClosed  TiDocumentText
import { TiDocumentText } from 'react-icons/ti'; //GoIssueClosed
import { RiUserSearchLine } from "react-icons/ri";

import { BootstrapTable, TableHeaderColumn, ExportCSVButton } from 'react-bootstrap-table';
import '../../node_modules/react-bootstrap-table/dist/react-bootstrap-table-all.min.css';
import AuthorizeRoute from './api-authorization/AuthorizeRoute';
import ApiAuthorizationRoutes from './api-authorization/ApiAuthorizationRoutes';
import { ApplicationPaths } from './api-authorization/ApiAuthorizationConstants';
import authService from './api-authorization/AuthorizeService';
import { FormGroup, Label,Input,Button, Popover, PopoverHeader, PopoverBody } from 'reactstrap';
import ModalsAlert from './ModalsAlert'
function afterSearch(searchText, result) {
  console.log('Your search text is ' + searchText);
  console.log('Result is:');
  for (let i = 0; i < result.length; i++) {
    console.log('Fruit: ' + result[i].id + ', ' + result[i].name + ', ' + result[i].price);
  }
}



export default class RevisarCreditosAdmin extends Component {

  constructor(props) {
    super(props);
      this.state = {
          business: [],
          mensajeModal: '',
          modal: false};
    this.options = {
      defaultSortName: 'fechaModificacion',  // default sort column name
      defaultSortOrder: 'desc',  // default sort order,
      exportCSVBtn: this.createCustomExportCSVButton
      }
      this.CerrarModal = this.CerrarModal.bind(this)
      this.sendDataServer = this.sendDataServer.bind(this)


  }
  componentDidMount() {
    //debugger;;

      this._subscription = authService.subscribe(() => this.populateState2());
      this.populateState2();


      
    }


    sendDataServer = () => {


        console.log('validation successful')

    }
    CerrarModal = () => {

      
        if (this.state.mensajeModal == "No tiene los permisos para ingresar a página") {


            this.props.history.push('/')
        } else {
            this.setState({
                modal: false

            })
        }


       
    }

    async populateState2() {
        const [isAuthenticated, user] = await Promise.all([authService.isAuthenticated(), authService.getUser()])
        console.log(user)
        this.setState({ UserIdLogin: user.sub }) 
        
        this.GetUserCurrent();

    }
    GetUserCurrent = () => {
        console.log(this.props.match.params.id)
        axios.get('/Api/Usuario/UsuarioRole?idEmpleado=' + this.state.UserIdLogin)
            //
            .then(response => {
                console.log(response);
                console.log(response.data);
                if (response.data.length > 0) {
                    this.setState({
                        Rol: response.data[0].role
                    })
                    if (this.state.Rol == "Vendedor") {

                        console.log('el usuario es vendedor')
                    } else if (this.state.Rol == "Analista de Crédito") {
                        console.log('el usuario es Analista de Crédito')

                    }
                    else if (this.state.Rol == "Admin") {

                        console.log('el usuario es Admin')
                    } else {

                        this.setState({
                            mensajeModal: "No tiene los permisos para ingresar a página"


                        })

                        this.setState({
                            modal: true

                        })
                    }
                } else {
                    
                    this.setState({
                        mensajeModal: "No tiene los permisos para ingresar a página"
                      

                    })

                    this.setState({
                        modal: true

                    })
                }
                
                this.iniciarBusqueda()
            })
            .catch(function (error) {
                console.log(error);
            })
        //
    }


    iniciarBusqueda() {
        axios.get('/Api/Credito/CreditodetailsRole?idEmpleado=' + this.state.UserIdLogin)//     /Api/Credito/Creditodetails
            .then(response => {
                this.setState({
                    business: response.data
                });
                //debugger;;
            })
            .catch(function (error) {
                console.log(error);
            })
    }

    iniciarBusquedaTotal() {
        axios.get('/Api/Credito/Creditodetails' )//     
            .then(response => {
                this.setState({
                    business: response.data
                });
                //debugger;;
            })
            .catch(function (error) {
                console.log(error);
            })
    }
  
    alerta(comments) {

        this.setState({
            mensajeModal: comments

        })

        this.setState({
            modal: true

        })

    }

  buttonFormatter(cell, row) {

       
      var enlace = ""
      var enlaceDocumentos = "/VerDocumentos/";
      var enlaceDocumentos = "/VerDocumentos/";
      var rutaIMSS = "Identity/Account/Manage/HistorialIMSS?generarHistorial=0&id=" + row.usuarioID
    



      if (this.state.Rol == "Vendedor") {
          if (row.estado == "ENVIADA") {

              enlace = "/solicitudDetail/";

              var comments = "sin comentarios"
              var disabled = "disabled"
              if (row.comentario !== null && row.comentario !== "undefined" && row.comentario !== "") {
                  comments = row.comentario
                  ///VerDocumentos/145
                  return <div>
                      <Link className="btn btn-success" to={enlace + row.id} title="Editar solicitud"><FiEdit3 /></Link> &nbsp;
                <Button onClick={() => this.alerta(comments)} value={comments}><MdTextsms /></Button>&nbsp;
                  <Link className="btn btn-info" to={enlaceDocumentos + row.id} title="Ver documentos"><TiDocumentText /></Link>&nbsp;
               <a className="btn btn-info" href={rutaIMSS} title="Reporte IMSS"><RiUserSearchLine /></a>&nbsp;
              </div>;

              } else {
                  return <div>
                      <Link className="btn btn-success" to={enlace + row.id} title="Editar solicitud"><FiEdit3 /></Link> &nbsp;
                <Button onClick={() => this.alerta(comments)} value={comments} disabled title="Sin comentarios"><MdTextsms /></Button>&nbsp;
                  <Link className="btn btn-info" to={enlaceDocumentos + row.id} title="Ver documentos"><TiDocumentText /></Link>&nbsp;
                  <a className="btn btn-info" href={rutaIMSS} title="Reporte IMSS"><RiUserSearchLine /></a>&nbsp;
              </div>;

              }
          }
          else if (row.estado == "APROBADA") {
              enlace = "/solicitudDetail/";

              var comments = "sin comentarios"
              var disabled = "disabled"
              if (row.comentario !== null && row.comentario !== "undefined" && row.comentario !== "") {
                  comments = row.comentario
                  ///VerDocumentos/145
                  return <div>
                      <Link className="btn btn-success" to={enlace + row.id} title="Editar solicitud"><FiEdit3 /></Link> &nbsp;
                <Button onClick={() => this.alerta(comments)} value={comments}><MdTextsms /></Button>&nbsp;
                  <Link className="btn btn-info" to={enlaceDocumentos + row.id} title="Ver documentos"><TiDocumentText /></Link>&nbsp;
               <a className="btn btn-info" href={rutaIMSS} title="Reporte IMSS"><RiUserSearchLine /></a>&nbsp;
              </div>;

              } else {
                  return <div>
                      <Link className="btn btn-success" to={enlace + row.id} title="Editar solicitud"><FiEdit3 /></Link> &nbsp;
                <Button onClick={() => this.alerta(comments)} value={comments} disabled title="Sin comentarios"><MdTextsms /></Button>&nbsp;
                  <Link className="btn btn-info" to={enlaceDocumentos + row.id} title="Ver documentos"><TiDocumentText /></Link>&nbsp;
                  <a className="btn btn-info" href={rutaIMSS} title="Reporte IMSS"><RiUserSearchLine /></a>&nbsp;
              </div>;

              }
          }

          else {
              enlace = "/solicitudDetail/";
              var comments = "sin comentarios"
              var disabled = "disabled"
              if (row.comentario !== null && row.comentario !== "undefined" && row.comentario !== "") {
                  comments = row.comentario
                  return <div>
                      <Link className="btn btn-success" to={enlace + row.id} title="Ver solicitud"><FaSearch /></Link>&nbsp;
                <Button onClick={() => this.alerta(comments)} value={comments}><MdTextsms /></Button>&nbsp;
                  <Link className="btn btn-info" to={enlaceDocumentos + row.id} title="Ver documentos"><TiDocumentText /></Link>&nbsp;
                  <a className="btn btn-info" href={rutaIMSS} title="Reporte IMSS"><RiUserSearchLine /></a>
                  </div>;

              } else {
                  return <div>
                      <Link className="btn btn-success" to={enlace + row.id} title="Ver solicitud"><FaSearch /></Link> &nbsp;
                <Button onClick={() => this.alerta(comments)} value={comments} disabled title="Sin comentarios"><MdTextsms /></Button>&nbsp;
                  <Link className="btn btn-info" to={enlaceDocumentos + row.id} title="Ver documentos"><TiDocumentText /></Link>&nbsp;
                  <a className="btn btn-info" href={rutaIMSS} title="Reporte IMSS"><RiUserSearchLine /></a>
                  </div>;

              }
              //FaCheck
          }



      }
      else if (this.state.Rol == "Analista de Crédito") {

          if (row.estado == "COMPLETA" || row.estado == "EN REVISIÓN" || row.estado == "EN REVISIÓN FIRMA Y SELFIE") {
              enlace = "/solicitudDetail/";

              var comments = "sin comentarios"
              var disabled = "disabled"
              if (row.comentario !== null && row.comentario !== "undefined" && row.comentario !== "") {
                  comments = row.comentario
                  ///VerDocumentos/145
                  return <div>
                      <Link className="btn btn-success" to={enlace + row.id} title="Editar solicitud"><FiEdit3 /></Link> &nbsp;
                <Button onClick={() => this.alerta(comments)} value={comments}><MdTextsms /></Button>&nbsp;
                  <Link className="btn btn-info" to={enlaceDocumentos + row.id} title="Ver documentos"><TiDocumentText /></Link>&nbsp;
               <a className="btn btn-info" href={rutaIMSS} title="Reporte IMSS"><RiUserSearchLine /></a>&nbsp;
              </div>;

              } else {
                  return <div>
                      <Link className="btn btn-success" to={enlace + row.id} title="Editar solicitud"><FiEdit3 /></Link> &nbsp;
                <Button onClick={() => this.alerta(comments)} value={comments} disabled title="Sin comentarios"><MdTextsms /></Button>&nbsp;
                  <Link className="btn btn-info" to={enlaceDocumentos + row.id} title="Ver documentos"><TiDocumentText /></Link>&nbsp;
                  <a className="btn btn-info" href={rutaIMSS} title="Reporte IMSS"><RiUserSearchLine /></a>&nbsp;
              </div>;

              }

              //
          }

                else {
              enlace = "/solicitudDetail/";
              var comments = "sin comentarios"
              var disabled = "disabled"
              if (row.comentario !== null && row.comentario !== "undefined" && row.comentario !== "") {
                  comments = row.comentario
                  return <div>
                      <Link className="btn btn-success" to={enlace + row.id} title="Ver solicitud"><FaSearch /></Link>&nbsp;
                <Button onClick={() => this.alerta(comments)} value={comments}><MdTextsms /></Button>&nbsp;
                  <Link className="btn btn-info" to={enlaceDocumentos + row.id} title="Ver documentos"><TiDocumentText /></Link>&nbsp;
                  <a className="btn btn-info" href={rutaIMSS} title="Reporte IMSS"><RiUserSearchLine /></a>
                  </div>;

              } else {
                  return <div>
                      <Link className="btn btn-success" to={enlace + row.id} title="Ver solicitud"><FaSearch /></Link> &nbsp;
                <Button onClick={() => this.alerta(comments)} value={comments} disabled title="Sin comentarios"><MdTextsms /></Button>&nbsp;
                  <Link className="btn btn-info" to={enlaceDocumentos + row.id} title="Ver documentos"><TiDocumentText /></Link>&nbsp;
                  <a className="btn btn-info" href={rutaIMSS} title="Reporte IMSS"><RiUserSearchLine /></a>
                  </div>;

              }
              //FaCheck
          }
      }
      else if ( this.state.Rol== "Admin") {
          //
      

          if (row.estado == "ENVIADA") {

              enlace = "/solicitudDetail/";

              var comments = "sin comentarios"
              var disabled = "disabled"
              if (row.comentario !== null && row.comentario !== "undefined" && row.comentario !== "") {
                  comments = row.comentario
                  ///VerDocumentos/145
                  return <div>
                      <Link className="btn btn-success" to={enlace + row.id} title="Editar solicitud"><FiEdit3 /></Link> &nbsp;
                <Button onClick={() => this.alerta(comments)} value={comments}><MdTextsms /></Button>&nbsp;
                  <Link className="btn btn-info" to={enlaceDocumentos + row.id} title="Ver documentos"><TiDocumentText /></Link>&nbsp;
               <a className="btn btn-info" href={rutaIMSS} title="Reporte IMSS"><RiUserSearchLine /></a>&nbsp;
              </div>;

              } else {
                  return <div>
                      <Link className="btn btn-success" to={enlace + row.id} title="Editar solicitud"><FiEdit3 /></Link> &nbsp;
                <Button onClick={() => this.alerta(comments)} value={comments} disabled title="Sin comentarios"><MdTextsms /></Button>&nbsp;
                  <Link className="btn btn-info" to={enlaceDocumentos + row.id} title="Ver documentos"><TiDocumentText /></Link>&nbsp;
                  <a className="btn btn-info" href={rutaIMSS} title="Reporte IMSS"><RiUserSearchLine /></a>&nbsp;
              </div>;

              }
          }
          else if (row.estado == "APROBADA") {
              enlace = "/solicitudDetail/";

              var comments = "sin comentarios"
              var disabled = "disabled"
              if (row.comentario !== null && row.comentario !== "undefined" && row.comentario !== "") {
                  comments = row.comentario
                  ///VerDocumentos/145
                  return <div>
                      <Link className="btn btn-success" to={enlace + row.id} title="Editar solicitud"><FiEdit3 /></Link> &nbsp;
                <Button onClick={() => this.alerta(comments)} value={comments}><MdTextsms /></Button>&nbsp;
                  <Link className="btn btn-info" to={enlaceDocumentos + row.id} title="Ver documentos"><TiDocumentText /></Link>&nbsp;
               <a className="btn btn-info" href={rutaIMSS} title="Reporte IMSS"><RiUserSearchLine /></a>&nbsp;
              </div>;

              } else {
                  return <div>
                      <Link className="btn btn-success" to={enlace + row.id} title="Editar solicitud"><FiEdit3 /></Link> &nbsp;
                <Button onClick={() => this.alerta(comments)} value={comments} disabled title="Sin comentarios"><MdTextsms /></Button>&nbsp;
                  <Link className="btn btn-info" to={enlaceDocumentos + row.id} title="Ver documentos"><TiDocumentText /></Link>&nbsp;
                  <a className="btn btn-info" href={rutaIMSS} title="Reporte IMSS"><RiUserSearchLine /></a>&nbsp;
              </div>;

              }
          }

          else if (row.estado == "COMPLETA" ||row.estado == "EN REVISIÓN" || row.estado == "EN REVISIÓN FIRMA Y SELFIE") {
          enlace = "/solicitudDetail/";
         
          var comments = "sin comentarios"
          var disabled = "disabled"
          if (row.comentario !== null && row.comentario !== "undefined" && row.comentario !== "") {
              comments = row.comentario
              ///VerDocumentos/145
              return <div>
                  <Link className="btn btn-success" to={enlace + row.id} title="Editar solicitud"><FiEdit3 /></Link> &nbsp;
                <Button onClick={() => this.alerta(comments)} value={comments}><MdTextsms /></Button>&nbsp;
                  <Link className="btn btn-info" to={enlaceDocumentos + row.id} title="Ver documentos"><TiDocumentText /></Link>&nbsp;
               <a className="btn btn-info" href= { rutaIMSS} title="Reporte IMSS"><RiUserSearchLine /></a>&nbsp;
              </div>;

          } else {
              return <div>
                  <Link className="btn btn-success" to={enlace + row.id} title="Editar solicitud"><FiEdit3 /></Link> &nbsp;
                <Button onClick={() => this.alerta(comments)} value={comments} disabled title="Sin comentarios"><MdTextsms /></Button>&nbsp;
                  <Link className="btn btn-info" to={enlaceDocumentos + row.id} title="Ver documentos"><TiDocumentText /></Link>&nbsp;
                  <a className="btn btn-info"  href={ rutaIMSS} title="Reporte IMSS"><RiUserSearchLine /></a>&nbsp;
              </div>;

          }
   
          //
      }
          else if (row.estado == "DISPERSADO") {
          enlace = "/solicitudDetail/";

        

          var comments = "sin comentarios"
          var disabled = "disabled"
          if (row.comentario !== null && row.comentario !== "undefined" && row.comentario !== "") {
              comments = row.comentario


              return <div>
                  <Link className="btn btn-success" to={enlace + row.id} title="Ver solicitud"><FaSearch /></Link>&nbsp;
                <Button onClick={() => this.alerta(comments)} value={comments}><MdTextsms /></Button>&nbsp;
                  <Link className="btn btn-info" to={enlaceDocumentos + row.id} title="Ver documentos"><TiDocumentText /></Link>&nbsp;

                  <a className="btn btn-info"  href={ rutaIMSS} title="Reporte IMSS"><RiUserSearchLine /></a>
              </div>;

          } else {
              return <div>
                  <Link className="btn btn-success" to={enlace + row.id} title="Ver solicitud"><FaSearch /></Link> &nbsp;
                <Button onClick={() => this.alerta(comments)} value={comments} disabled title="Sin comentarios"><MdTextsms /></Button>&nbsp;
                  <Link className="btn btn-info" to={enlaceDocumentos + row.id} title="Ver documentos"><TiDocumentText /></Link>&nbsp;
                  <a className="btn btn-info"  href={ rutaIMSS} title="Reporte IMSS"><RiUserSearchLine /></a>
              </div>;

          }
      }

          else if (row.estado == "CONTRATO ANEXADO") {
          enlace = "/solicitudDetail/";

          
          var comments = "sin comentarios"
          var disabled = "disabled"
          if (row.comentario !== null && row.comentario !== "undefined" && row.comentario !== "") {
              comments = row.comentario


              return <div>
                  <Link className="btn btn-success" to={enlace + row.id} title="Ver solicitud"><FaSearch /></Link>&nbsp;
                <Button onClick={() => this.alerta(comments)} value={comments}><MdTextsms /></Button>&nbsp;
                  <Link className="btn btn-info" to={enlaceDocumentos + row.id} title="Ver documentos"><TiDocumentText /></Link>&nbsp;
                  <a className="btn btn-info"  href={ rutaIMSS} title="Reporte IMSS"><RiUserSearchLine /></a>
              </div>;

          } else {
              return <div>
                  <Link className="btn btn-success" to={enlace + row.id} title="Ver solicitud"><FaSearch /></Link> &nbsp;
                <Button onClick={() => this.alerta(comments)} value={comments} disabled title="Sin comentarios"><MdTextsms /></Button>&nbsp;
                  <Link className="btn btn-info" to={enlaceDocumentos + row.id} title="Ver documentos"><TiDocumentText /></Link>&nbsp;
                  <a className="btn btn-info"  href={ rutaIMSS} title="Reporte IMSS"><RiUserSearchLine /></a>
              </div>;

          }
          //FaCheck
      }
          else if (row.estado == "RECHAZAR SOLICITUD") {
          enlace = "/solicitudDetail/";
         
          var comments = "sin comentarios"
          var disabled = "disabled"
          if (row.comentario !== null && row.comentario !== "undefined" && row.comentario !== "") {
              comments = row.comentario
              

              return <div>
                  <Link className="btn btn-success" to={enlace + row.id} title="Ver solicitud"><FaSearch /></Link> &nbsp;
                <Button onClick={() => this.alerta(comments)} value={comments}><MdTextsms /></Button>&nbsp;
                  <Link className="btn btn-info" to={enlaceDocumentos + row.id} title="Ver documentos"><TiDocumentText /></Link>&nbsp;
                  <a className="btn btn-info"  href={ rutaIMSS} title="Reporte IMSS"><RiUserSearchLine /></a>
              </div>;

          } else {
              return <div>
                  <Link className="btn btn-success" to={enlace + row.id} title="Ver solicitud"><FaSearch /></Link> &nbsp;
                <Button onClick={() => this.alerta(comments)} value={comments} disabled title="Sin comentarios"><MdTextsms /></Button>&nbsp;
                  <Link className="btn btn-info" to={enlaceDocumentos + row.id} title="Ver documentos"><TiDocumentText /></Link>&nbsp;
                  <a className="btn btn-info"  href={ rutaIMSS} title="Reporte IMSS"><RiUserSearchLine /></a>
              </div>;

          }
         
      }

          else if (row.estado == "REQUIERE CAMBIOS" || row.estado == "REQUIERE CAMBIOS EN FIRMA O SELFIE") {
          enlace = "/solicitudDetail/";

         
          var comments = "sin comentarios"
          var disabled = "disabled"
          if (row.comentario !== null && row.comentario !== "undefined" && row.comentario !== "") {
              comments = row.comentario


              return <div>
                  <Link className="btn btn-success" to={enlace + row.id} title="Ver solicitud"><FaSearch     /></Link>&nbsp;
                <Button onClick={() => this.alerta(comments)} value={comments}><MdTextsms /></Button>&nbsp;
                  <Link className="btn btn-info" to={enlaceDocumentos + row.id} title="Ver documentos"><TiDocumentText /></Link>&nbsp;
                  <a className="btn btn-info"  href={ rutaIMSS} title="Reporte IMSS"><RiUserSearchLine /></a>
              </div>;

          } else {
              return <div>
                  <Link className="btn btn-success" to={enlace + row.id} title="Ver solicitud"><FaSearch /></Link>&nbsp;
                <Button onClick={() => this.alerta(comments)} value={comments} disabled title="Sin comentarios"><MdTextsms /></Button>&nbsp;
                  <Link className="btn btn-info" to={enlaceDocumentos + row.id} title="Ver documentos"><TiDocumentText /></Link>&nbsp;
                  <a className="btn btn-info"  href={ rutaIMSS} title="Reporte IMSS"><RiUserSearchLine /></a>
              </div>;

          }

      }
      //

      else {
          enlace = "/solicitudDetail/";

          return <div>

              <Link className="btn btn-success" to={enlace + row.id} title="Ver solicitud"><FaSearch /></Link> &nbsp; </div>;
      }
      }

    }

    ButtonEstado(cell, row) {

        var enlace = ""
        console.log("*************************")
        console.log(row)
        console.log(cell)
        console.log(row)
        console.log(this.state)
        console.log("xxxxxxxxxxxxxxxxxxxxxxxxxxxx")
        if (this.state.Rol == "Admin" || this.state.Rol == "Vendedor" || this.state.Rol == "Analista de Crédito") {
            console.log(row.rol)
            console.log(row.estado)
            if (row.estado == "ENVIADA") {
                return <div className="alinearCelda">

                    <Button className="btn btn-info" disabled title={row.estado}><FiEdit3 /></Button>
                </div>;
            }

            else if (row.estado == "COMPLETA") {
                return <div className="alinearCelda">

                    <Button className="btn btn-info" disabled title={row.estado}><FiEdit3 /></Button>
                </div>;
            }
            else if (row.estado == "APROBADA") {
                return <div className="alinearCelda">

                    <Button className="btn btn-success" disabled title={row.estado}><GoChecklist /></Button>
                </div>;
            }
            else if (row.estado == "EN REVISIÓN") {


                return <div className="alinearCelda">

                    <Button className="btn btn-info" disabled title={row.estado}><FiEdit3 /></Button>
                </div>;
            }
            else if (row.estado == "DISPERSADO") {
                return <div className="alinearCelda">

                    <Button className="btn btn-success" disabled title={row.estado}><FaCheckDouble /></Button>
                </div>;

            }
            else if (row.estado == "EN REVISIÓN FIRMA Y SELFIE") {


                return <div className="alinearCelda">

                    <Button className="btn btn-info" disabled title={row.estado}><AiOutlineFileSearch /></Button>
                </div>;

            }
            else if (row.estado == "CONTRATO ANEXADO") {
                return <div className="alinearCelda">

                    <Button className="btn btn-success" disabled title={row.estado}><FaCheck /></Button>
                </div>;

            }
            else if (row.estado == "RECHAZAR SOLICITUD") {

                return <div className="alinearCelda">
                    <Button className="btn btn-danger" disabled title={row.estado}><MdClose /></Button>
                </div>;

            }

            else if (row.estado == "REQUIERE CAMBIOS" || row.estado == "REQUIERE CAMBIOS EN FIRMA O SELFIE") {

                return <div className="alinearCelda">

                    <Button className="btn btn-warning" disabled title={row.estado}><GoIssueClosed /></Button>
                </div>;
            }
            else {

                return <div className="alinearCelda">

                    <Button className="btn btn-secondary" disabled title={row.estado}><FaSearch /></Button>
                </div>;
            }

        } else {
         
            return <div className="alinearCelda">

                <Button className="btn btn-secondary" disabled title={row.estado}><FaSearch /></Button>
            </div>;

        } 

    }

  
  MontoFormatter(cell, row) {
    let numero = new Intl.NumberFormat("es-MX", {
      style: "currency",
      currency: "MXN"
    }).format(row.montocredito)
    console.log(numero)

    return <div>{numero} </div>;

  }
  Montodate(cell, row) {
    
      console.log(row.fechaModificacion)
      var date = new Date(row.fechaModificacion);

      var fecha = new Intl.DateTimeFormat("es-MX", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit"
      }).format(date)
    
    return <div>{fecha} </div>;

  }
  handleExportCSVButtonClick = (onClick) => {
    // Custom your onClick event here,
    // it's not necessary to implement this function if you have no any process before onClick
    console.log('This is my custom function for ExportCSVButton click event');
    onClick();
  }
  createCustomExportCSVButton = (onClick) => {
    return (
      <ExportCSVButton
        btnText='Exportar a csv'
        btnContextual='btn-info'
        className='my-custom-class'
        btnGlyphicon='glyphicon-edit'
        onClick={e => this.handleExportCSVButtonClick(onClick)} />
    );
    // If you want have more power to custom the child of ExportCSVButton,
    // you can do it like following
    // return (
    //   <ExportCSVButton
    //     btnContextual='btn-warning'
    //     className='my-custom-class'
    //     onClick={ () => this.handleExportCSVButtonClick(onClick) }>
    //     { ... }
    //   </ExportCSVButton>
    // );
  }
    handleChangeFiltro = (e) => {
      
        console.log(e.target.name)
        console.log(e.target.value)
        if (e.target.value =='TODAS LAS SOLICITUDES') {
            this.iniciarBusquedaTotal()
        } else {
            this.iniciarBusqueda()
           
        }
        //this.setState({ [e.target.name]: e.target.value });
        //console.log(this.state)
    }
    
  render() {
    const options = {
      defaultSortName: 'fechaModificacion',  // default sort column name
      defaultSortOrder: 'desc',  // default sort order,
      exportCSVBtn: this.createCustomExportCSVButton
      };
      function filterdate(cell, row) {
          // just return type for filtering or searching.
          console.log(cell.type)
          var date = new Date(row.fechaModificacion);

          var fecha = new Intl.DateTimeFormat("es-MX", {
              year: "numeric",
              month: "2-digit",
              day: "2-digit"
          }).format(date)
          return fecha;
      }
      function filterMonto(cell, row) {
          // just return type for filtering or searching.
          let numero = new Intl.NumberFormat("es-MX", {
              style: "currency",
              currency: "MXN"
          }).format(row.montocredito)
          console.log(numero)
          return numero;
      }

  
       return (
      <div className="TablaSolicitudes">
              
               <h2 className="PageHeading" >Solicitudes</h2>
               <hr />

               <FormGroup>
                   <Label for="exampleSelect">Solicitudes</Label>
                   <Input type="select" name="FiltroTabla" id="FiltroTabla" onChange={this.handleChangeFiltro}  >
                       <option>EN PROCESO</option>
                       <option>TODAS LAS SOLICITUDES</option>
                   </Input>
               </FormGroup>
              
        <BootstrapTable data={this.state.business} search={true} options={options} searchPlaceholder={'Buscador'} exportCSV={true} options={this.options} pagination striped hover condensed>
             <TableHeaderColumn isKey dataField='id' hidden={true} dataSort={true}>ID</TableHeaderColumn>
             <TableHeaderColumn dataField='usuarioID' hidden={true} dataSort={true}>usuarioID</TableHeaderColumn>
             <TableHeaderColumn dataField='company' width='150' dataSort={true}>Empresa</TableHeaderColumn>
          <TableHeaderColumn dataField='apellidoP' width='150'  dataSort={true}>Apellido</TableHeaderColumn>
             <TableHeaderColumn dataField='nombres' width='150' dataSort={true}>Nombres</TableHeaderColumn>
                   <TableHeaderColumn dataField='comentario' hidden={true} width='150' dataSort={false}>ID</TableHeaderColumn>
          
                   <TableHeaderColumn dataField='fechaModificacion' width='185' filterValue={filterdate}  dataSort={true} dataFormat={this.Montodate.bind(this)}>Fecha de modificación</TableHeaderColumn>
                   <TableHeaderColumn dataField='montocredito' width='120' dataSort={true} filterValue={filterMonto} dataFormat={this.MontoFormatter.bind(this)}>Monto</TableHeaderColumn>
                   <TableHeaderColumn dataField='estado' width='90' dataFormat={this.ButtonEstado.bind(this)} dataSort={true}>Estado</TableHeaderColumn>
                   <TableHeaderColumn dataField="button" width='180' export={false} dataFormat={this.buttonFormatter.bind(this)}>Acción</TableHeaderColumn>
                   <TableHeaderColumn dataField='rol' hidden={true} dataSort={true}>Rol</TableHeaderColumn>

               </BootstrapTable>
               <ModalsAlert state={this.state} CerrarModal={this.CerrarModal} isOpen={this.state.modal} sendDataServer={this.sendDataServer} />   
      </div>
    );
  }
}

